module.exports = __webpack_public_path__ + "img/delivery-dates.616647d5.svg";